var debug = false;

const heritageTimeline = () => {
  const timelineContainer = document.querySelector(".timeline");

  if (!timelineContainer) {
    return;
  }

  if (debug) {
    console.log("heritageTimeline");
  }

  const timelineBtns = Array.from(
    timelineContainer.querySelectorAll(".js-timeline-btn")
  );

  timelineBtns.forEach((timelineBtn) => {
    timelineBtn.addEventListener("click", (e) => {
      e.cancelBubble = true;
      const datatimelineBtn = timelineBtn.getAttribute("data-timeline");
      const timelineBtnTarget = timelineContainer.querySelector(
          '.js-timeline-dialog[data-timeline="' + datatimelineBtn + '"]'
      );
      timelineBtnTarget.toggleAttribute("open");
      timelineBtn.classList.toggle('-active');
    });
  });
};

heritageTimeline();
